import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { WEARABLE_OBSERVATION_METHOD } from "./wearableObservationBuilder";

/** Monta payload FHIR garantindo method wearable (objeto plain para serialização no axios). */
function buildWearableObservationPayload(
  observation: Record<string, unknown>
): Record<string, unknown> {
  return {
    ...observation,
    method: {
      coding: WEARABLE_OBSERVATION_METHOD.coding.map((coding) => ({
        ...coding,
      })),
    },
  };
}

/**
 * POST de Observation FHIR já montada (wearable / LOINC).
 * Usa os mesmos headers de PostObservation (subject-id / organization-id quando existirem).
 */
export async function PostWearableObservationResource(
  observation: Record<string, unknown>
) {
  const url = `${endpoints.EHRPOSTER}/Observation`;

  // Garante method no recurso antes do envio (origem wearable).
  const payload = buildWearableObservationPayload(observation);

  const subjectId = await useAuth.getSubjectId();
  const organizationId = await useAuth.getOrganizationId();

  const headers = {
    Accept: "application/fhir+json",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
    ...(subjectId && { "subject-id": subjectId }),
    ...(organizationId && { "organization-id": organizationId }),
  };

  const response = await useAxios
    .post(url, payload, { headers, timeout: 20000 })
    .then((res) => {
      if (
        res.status !== HTTPResponseStatus.Created &&
        res.status !== HTTPResponseStatus.Success
      ) {
        throw new Error(`PostWearableObservation: ${res.status}`);
      }
      return res.data;
    })
    .catch((error) => {
      console.error("PostWearableObservation ", error);
      toast.error(
        `Erro ao enviar observação: ${error?.response?.status ?? error?.message}`
      );
      throw error;
    });

  return response;
}
